export const floatToIntegerCurrency = (inputAmount: number) =>
  parseInt(((inputAmount * 100) / 100).toFixed(2).replace('.', ''), 10)
